import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'Actions/router';
import * as iconStyles from '.../../styles/icons.css';
import * as styles from './sidebar.css';

const Sidebar = ({
  editable,
  selectedIndicators,
  onClick,
  onClear,
  onEdit,
}) => (
  <div className={styles.sidebar}>
    <div className={styles.header}>
      <h3>Your Indicator Selections</h3>
      {editable ?
        (<button
          className={styles.manage}
          onClick={() => onClear(selectedIndicators)}
        >Clear All</button>) :
        (<button className={styles.manage} onClick={onEdit}>Edit</button>)}
    </div>
    <div className={styles.content}>
      { !selectedIndicators ?
          (<span>Choose Indicators and review your selections here</span>) :
          (<ul>{selectedIndicators.map(({ id, name, parent }) => (
            <li key={id}>
              {editable && (
                <button className={styles.remove} onClick={() => onClick(id)}>
                  <i className={iconStyles.iconClose} />
                </button>
              )}
              <span>{parent && `${parent} `}{name}</span>
            </li>))}
          </ul>) }
    </div>
  </div>
);

Sidebar.propTypes = {
  editable: PropTypes.bool.isRequired,
  selectedIndicators: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.object
    ),
  ]).isRequired,
  onClick: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

const mapStateToProps = ({
  router: { view, indicators: active = false },
  data: { indicators },
}) => ({
  editable: '1' === view,
  selectedIndicators: active && (
    Array.isArray(active) ?
      active.map((id) => ({ ...indicators[id], id })) :
      [{ ...indicators[active], id: active }]
  ).map((indicator) => ({
    ...indicator,
    parent: (Object.values(indicators)
      .filter(({ children = false }) => children && children.length)
      .find(({ children }) => -1 < children.indexOf(indicator.id)) || {})
      .name,
  })),
});

const mapDispatchToProps = (dispatch) => ({
  onClick: (id) => dispatch(push({ indicators: id })),
  onClear: (selectedIndicators) => selectedIndicators.forEach(
    ({ id }) => dispatch(push({ indicators: id }))
  ),
  onEdit: () => dispatch(push({ view: 1 })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Sidebar);

// Testing exports
export {
  Sidebar,
  mapStateToProps,
  mapDispatchToProps,
};



// WEBPACK FOOTER //
// ./app/components/sidebar/index.js